import React from 'react';
import { Icon } from 'semantic-ui-react';
import './Landing.css';

const FixtureCard = ({ event, isSpecial }) => {
  const { event_day, event_month, event_name, event_location, event_club } = event;

  // Format date like "Dec 10"
  const monthShort = event_month ? event_month.substring(0, 3) : '';
  const formattedDate = `${monthShort} ${event_day}`;

  return (
    <div className="fixture-card">
      <div className="fixture-date">{formattedDate}</div>

      <div className="fixture-content">
        <div className="fixture-title">{event_name || event_club}</div>
        <div className="fixture-location">
          <Icon name="map marker alternate" size="small" />
          {event_location}
        </div>
      </div>

      {isSpecial && <span className="special-badge">Special</span>}
    </div>
  );
};

export default FixtureCard;
